import { useState, useEffect, createContext } from "react";
import * as Utils from "../Utils/index";
import { ROLES } from "../Constants/Strings";

export const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState("");
  const [loading, setLoading] = useState(true);

  const login = (user) => {
    Utils.setUser(user);
    setUser(user);
  };

  const logout = () => {
    Utils.removeCookie("user");
    setUser("");
  };
  // const isAdminOrHO = [ROLES.ADMIN_ROLE].includes(user?.role?.toLowerCase());
  const isAdminOrHO = [ROLES.ADMIN_ROLE, ROLES.DIRECTOR_MANAGEMENT].includes(user?.role?.toLowerCase());
  const nonStaffAccess = [ROLES.ADMIN_ROLE, ROLES.INCHARGE, ROLES.PROJECT_INCHARGE, ROLES.DIRECTOR_MANAGEMENT].includes(
    user?.role?.toLowerCase()
  );


  useEffect(() => {
    const fetchUser = async () => {
      const userData = await Utils.getUser();
      setUser(userData);
      setLoading(false);
    };

    fetchUser();
  }, []);

 
  const values = {
    user,
    setUser,
    login,
    logout,
    isAdminOrHO,
    nonStaffAccess,
    loading,
  };

  if (!loading) {
    return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
  }

};

export default UserContextProvider;
